exports.getPointWidth = (currentBreakpoint) => {
    let pointWidth;
    switch (currentBreakpoint) {
    case 'xs':
        pointWidth = 100;
        break;
    case 'sm':
        pointWidth = 200;
        break;
    case 'md':
        pointWidth = 225;
        break;
    default:
        pointWidth = 250;
    }
    return pointWidth;
};



// WEBPACK FOOTER //
// ./src/helpers/labs/charts.js